import React, { useState } from "react";
import { Link } from "react-router-dom";
import projects from "../data/projects";
import Modal from "../components/Modal";

function Projects() {
  const [active, setActive] = useState(null);

  return (
    <main className="page-main fade-up">
      <Link to="/" className="back-link">
        ← Index
      </Link>
      <div className="eyebrow">(01) — Built</div>
      <h1 className="page-title">
        projects &amp;<br />
        learnings
      </h1>
      <p className="page-intro">
        all built / some shipped — & lessons left behind
      </p>

      <div className="list">
        {projects.map((item) => (
          <button
            key={item.n}
            className="project-row"
            onClick={() => setActive(item)}
          >
            <span className="project-n">{item.n}</span>
            <div>
              <h3 className="project-name">{item.name}</h3>
              <p className="project-kind">{item.kind}</p>
              <div className="tag-row">
                {item.tags.map((tag) => (
                  <span key={tag} className="tag">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="project-learn-col">
              <div className="project-learn-label">
                lesson learned · {item.year}
              </div>
              <p className="project-learn">{item.learned}</p>
            </div>
          </button>
        ))}
      </div>

      {active && (
        <Modal onClose={() => setActive(null)}>
          <div className="modal-eyebrow">Project · {active.year}</div>
          <h2 className="modal-title">{active.name}</h2>
          <p className="modal-sub">{active.kind}</p>
          <div className="tag-row" style={{ marginTop: "18px" }}>
            {active.tags.map((tag) => (
              <span key={tag} className="tag">
                {tag}
              </span>
            ))}
          </div>
          {active.body ? (
            <div className="modal-body">{active.body}</div>
          ) : (
            <>
              <p className="modal-body">{active.learned}</p>
              <p className="modal-placeholder">Full case study coming soon.</p>
            </>
          )}
        </Modal>
      )}
    </main>
  );
}

export default Projects;
